import { ColorPicker } from '../config/ColorPicker';

const colorFinder = (colorName) => {
  return ColorPicker.find((color) => color.colorName === colorName);
};

export default colorFinder;
